export const PlainButtonStyles = {
    neutral:
        "w-full rounded-full border border-[#E2E8F0] bg-white px-4 py-2 text-[#64748B] font-semibold transition-colors hover:bg-[#F8FAFC] disabled:cursor-not-allowed disabled:opacity-50",
    wrapper: "w-4/5",
    wrapperFull: "w-full",
    clickable: "rounded-lg text-center cursor-pointer",
    inner: "py-2 px-2 font-bold bg-white rounded-lg",
    innerGradientHover: "hover:bg-none hover:bg-[#FFF2F2] hover:text-[#E64E4E]",
    button: "font-bold",
};
